var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loader)?_c(_vm.loader,{tag:"component",attrs:{"detailLayout":_vm.detailLayout,"utilityData":_vm.utilityData,"utilityKey":_vm.utilityKey}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }